export default "__VITE_ASSET__9ae56149__"